import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper";
import Api from "../Api";
import {QRCodeSVG} from 'qrcode.react';
import {qrTrans} from "../translate";

function QrLogin(props) {
    const [qrToken, setQrToken] = useState('');
    const [authenticated, setAuthenticated] = useState(false);
    const pollSession = async (token) => {
        const res = await Api.checkQR(token);
        if (res.data.authenticated) {
            clearInterval(interval);
            setAuthenticated(true);
            // Optionally log in user with `res.data.userId`
        }
    };

    useEffect(() => {
        const createQRSession = async () => {
            const {data} = await Api.createQR()
            setQrToken(data.qrToken);
            await pollSession(data.qrToken);
        };

        createQRSession();
    }, []);

    return (
        <Wrapper>
            <div className="tableParent" id="tableParent">
                <div className="qrLogin">
                    {authenticated ? (
                        <p>✅ Logged in via mobile</p>
                    ) : (
                        <>
                            <QRCodeSVG value={qrToken}/>
                            <div>
                                <h3 className="text-center">{qrTrans.header[+localStorage.getItem('atsLang') || 1]}</h3>
                                <ol>
                                    <li>
                                        {qrTrans.step1[+localStorage.getItem('atsLang') || 1]}
                                    </li>
                                    <li>
                                        {qrTrans.step2[+localStorage.getItem('atsLang') || 1]}
                                    </li>
                                    <li>
                                        {qrTrans.step3[+localStorage.getItem('atsLang') || 1]}
                                    </li>
                                </ol>

                            </div>
                        </>
                    )}
                </div>
            </div>
        </Wrapper>
    );
}

export default QrLogin;